// Google Analytics 4 con Consent Mode: solo se carga tras el consentimiento
// del visitante (banner de cookies de ATENTO). Sin Measurement ID, no carga nada.
const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const CONSENT_KEY = "atento-cookie-consent";
const GA_SCRIPT_ID = "google-analytics-gtag";

function accepted() {
  try {
    return window.localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
}

function createGtagQueue() {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
}

function setConsent(value) {
  if (typeof window.gtag !== "function") return;
  const state = value === "accepted" ? "granted" : "denied";
  window.gtag("consent", "update", {
    analytics_storage: state,
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
}

function initializeGA4() {
  if (!MEASUREMENT_ID || window.__atentoGA4Initialized) return;

  createGtagQueue();

  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  const script = document.createElement("script");
  script.id = GA_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  document.head.appendChild(script);

  window.gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID, {
    anonymize_ip: true,
    send_page_view: true,
  });

  window.__atentoGA4Initialized = true;
}

export function startAnalyticsIfConsented() {
  if (accepted()) initializeGA4();
}

export function trackPageView() {
  if (!accepted() || typeof window.gtag !== "function" || !MEASUREMENT_ID) return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search,
  });
}

export function installConsentListener() {
  startAnalyticsIfConsented();

  window.addEventListener("atento:consent-changed", (event) => {
    const value = event?.detail?.value || window.localStorage.getItem(CONSENT_KEY);
    if (value === "accepted") {
      initializeGA4();
    } else if (value === "rejected") {
      setConsent("rejected");
    }
  });
}
